
export const NEW_FIELD_FIELD_CHANGE = 'NEW_FIELD_FIELD_CHANGE';
export const OPEN_NEW_FIELD_DIALOG = 'OPEN_NEW_FIELD_DIALOG';
export const CLOSE_NEW_FIELD_DIALOG = 'CLOSE_NEW_FIELD_DIALOG';
export const ADD_NEW_FIELD = 'ADD_NEW_FIELD';
export const NEW_FIELD_ADDED = 'NEW_FIELD_ADDED';